import { render, staticRenderFns } from "./keyWordSearch.vue?vue&type=template&id=4355dc62&scoped=true&"
import script from "./keyWordSearch.vue?vue&type=script&lang=js&"
export * from "./keyWordSearch.vue?vue&type=script&lang=js&"
import style0 from "./keyWordSearch.vue?vue&type=style&index=0&id=4355dc62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4355dc62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4355dc62')) {
      api.createRecord('4355dc62', component.options)
    } else {
      api.reload('4355dc62', component.options)
    }
    module.hot.accept("./keyWordSearch.vue?vue&type=template&id=4355dc62&scoped=true&", function () {
      api.rerender('4355dc62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customerService/keyWordSearch.vue"
export default component.exports